import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import PanelContent from './PanelContent';
import PanelFooter from './PanelFooter';
import PanelHeader from './PanelHeader';
import PanelSubHeader from './PanelSubHeader';

import './Panel.scss';

class Panel extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    footer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    handleScroll: PropTypes.func,
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    subHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    loading: PropTypes.bool,
    nopadding: PropTypes.bool,
    disabled: PropTypes.bool,
    forwardedRef: PropTypes.node
  };

  handleScroll = (event) => {
    this.props.handleScroll && this.props.handleScroll(event);
  };

  render() {
    const {
      children,
      className,
      header,
      subHeader,
      footer,
      nopadding,
      disabled,
      forwardedRef
    } = this.props;

    const classComponent = classNames(
      'panel',
      'panel--default',
      { 'panel--nopadding': nopadding },
      { 'panel--disabled': disabled },
      className
    );

    return (
      <div className={classComponent} onScroll={this.handleScroll.bind(this)}>
        {header && <PanelHeader>{header}</PanelHeader>}

        {subHeader && <PanelSubHeader>{subHeader}</PanelSubHeader>}

        {children && <PanelContent ref={forwardedRef}>{children}</PanelContent>}

        {footer && <PanelFooter>{footer}</PanelFooter>}
      </div>
    );
  }
}

const WrappedComponent = React.forwardRef((props, ref) => {
  return <Panel {...props} forwardedRef={ref} />;
});

export default WrappedComponent;
